module.exports = __webpack_public_path__ + "static/media/back.d47a30df.svg";